export default __webpack_public_path__ + "static/media/glute_bridge.74718d1c.svg";